import React from "react";
import StatusPage from "./StatusPage";
import { LockLineIcon } from "../../components/common/Icons/Icons";

const AccessDenied = () => (
    <StatusPage
        code="401"
        title="Access denied"
        message="Your account doesn't have permission to view this page."
        icon={<LockLineIcon/>}
    />
);

export default AccessDenied;
